import React, { memo, useMemo } from "react";

import { useFormContext } from "react-hook-form";

import { RadioGroupInput, RouterActions, StyledHeading } from "@/components";
import { StyledQuestion } from "@/components/StyledQuestion";
import { useFieldValidation } from "@/hooks";
import { PageBaseProps } from "@/types/SolarFormProps";

import { existingSolar } from "./content.json";
import { isBatteryJourney } from "./utils/formJourney";
import { requireSolarRoute } from "./utils/requireSolarRoute";

const { heading, id, option } = existingSolar;

const SolarAndSolarBatteryJourneyContent = () => {
  return (
    <div data-id="solar-and-solar-battery-content">
      <StyledHeading>{heading.solarAndSolarBatteryJourney}</StyledHeading>
      <RadioGroupInput
        data-id={id}
        name="existingSolar"
        label=""
        options={option.solarAndSolarBatteryJourney}
      />
    </div>
  );
};

const BatteryJourneyContent = ({
  hasSolarPanels,
}: {
  hasSolarPanels: boolean;
}) => {
  return hasSolarPanels ? (
    <div data-id="battery-has-solar-panels-content">
      <StyledHeading>{heading.batteryJourney.detected}</StyledHeading>
      <RadioGroupInput
        data-id={id}
        name="existingSolar"
        label=""
        options={option.batteryJourney.detected}
      />
    </div>
  ) : (
    <div data-id="battery-not-have-solar-panels-content">
      <StyledHeading>{heading.batteryJourney.notDetected}</StyledHeading>
      <RadioGroupInput
        data-id={id}
        name="existingSolar"
        label=""
        options={option.batteryJourney.notDetected}
      />
    </div>
  );
};

export const ExistingSolar = memo(({ backRoute, nextRoute }: PageBaseProps) => {
  const { isValid } = useFieldValidation({ fields: ["existingSolar"] });
  const { getValues } = useFormContext();
  const systemType = getValues("systemType");
  const hasSolarPanels = requireSolarRoute(getValues("accurassiHasSolarPanel"));

  const batteryJourney = useMemo(
    () => isBatteryJourney(systemType),
    [systemType]
  );

  const handleOnNext = async () => {
    if (!batteryJourney) {
      return isValid();
    }

    const existingSolarAnswer = getValues("existingSolar");

    return Promise.resolve(
      (await isValid()) && existingSolarAnswer === "existing solar (PV) system"
    );
  };

  return (
    <StyledQuestion>
      {batteryJourney ? (
        <BatteryJourneyContent hasSolarPanels={hasSolarPanels} />
      ) : (
        <SolarAndSolarBatteryJourneyContent />
      )}
      <RouterActions
        onBackRoute={backRoute}
        onNextRoute={nextRoute}
        onNext={handleOnNext}
      />
    </StyledQuestion>
  );
});
